var map = {
	"./favicon.png": "2028",
	"./index.html": "2a19",
	"./pin-core.png": "adcc",
	"./pin-deep-core.png": "5ef6",
	"./pin-input.png": "b986",
	"./pin-matriz.png": "f2ae",
	"./pin-neural-core.png": "962e",
	"./pin-nexus.png": "f76f",
	"./pin-node-1000.png": "40af",
	"./pin-node-500.png": "41fb",
	"./pin-node.png": "930b",
	"./pin-omni-core.png": "ba94",
	"./pin-quantum-core.png": "a671",
	"./pin-singulary.png": "06f6",
	"./pin-synapse.png": "4439"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";